import { render, staticRenderFns } from "./custDialog.vue?vue&type=template&id=2b83c593&"
import script from "./custDialog.vue?vue&type=script&lang=js&"
export * from "./custDialog.vue?vue&type=script&lang=js&"
import style0 from "./custDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports